var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var CommentsCollection = require('../../collections/comments-collection');
var CommonUtils = require('../../utils/common-utils.js');

var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');

var Radio = require('backbone.radio');
var actionsChannel = Radio.channel('actions');
var notificationsChannel = Radio.channel('notifications');

var utils = new CommonUtils();

var CommentRowView = Marionette.View.extend({
    tagName: 'div',

    template: require('../../templates/comments/comments-row.html'),

    ui: {
        //edit: '.edit-comment',
        //remove: '.remove-comment'
        setAsIrrelevant: ".set-as-irrelevant"
    },
    events: {
        //'click @ui.edit': 'onEdit',
        //'click @ui.remove': 'onRemove'
        'click @ui.setAsIrrelevant': 'onSetAsIrrelevant'
    },

    templateContext: function () {
        var that = this;
        var commenter = that.model.get('commentedBy');
        return {
            creator: commenter ? commenter.name : '',
            creatorId: commenter ? commenter.id : '',
            time: utils.longToDateTimeFormatted(Number(that.model.get('time')), 'MMM DD YYYY hh:mm A'),
            text: (that.model.get('text') || '').replace(/\r?\n/g, '<br />'),
            canEdit: that.getOption('canEdit'),
            id: that.model.get('id')
        }
    },

    initialize: function (options) {
    },

    /*onEdit: function () {
        this.triggerMethod('on:edit:comment', this.model);
    },

    onRemove: function () {
        this.triggerMethod('on:remove:comment', this.model);
    },*/

    onSetAsIrrelevant: function () {
        this.triggerMethod('on:irrelevant:comment', this.model);
    }
});

var CommentsTableBody = Marionette.CollectionView.extend({
    tagName: 'div',
    childView: CommentRowView,

    collectionEvents: {},

    childViewEvents: {
        //'on:edit:comment': 'onEditComment',
        //'on:remove:comment': 'onRemoveComment'
        'on:irrelevant:comment': 'onSetAsIrrelevant'
    },

    childViewOptions: function () {
        var that = this;
        return {
            canEdit: that.getOption('canEdit')
        };
    },

    initialize: function (options) {
        this.collection = options.collection;
    },

    /*onEditComment: function (model) {
        this.triggerMethod('on:edit:comment', model);
    },

    onRemoveComment: function (model) {
        this.triggerMethod('on:remove:comment', model);
    },*/

    onSetAsIrrelevant: function (model) {
        this.triggerMethod('on:irrelevant:comment', model);
    }
});

var CommentsTableView = Marionette.View.extend({
    tagName: 'div',
    //className: 'comments-table',
    template: require('../../templates/comments/comments-table.html'),

    regions: {
        body: {
            el: '.list-of-comments',
            replaceElement: true
        },
        confirmationModal: '#confirmation-modal'
    },

    ui: {
        scrollToNew: '#scroll-to-add'
    },

    events: {
      'click @ui.scrollToNew': 'addNewComment'
    },

    childViewEvents: {
        //'on:edit:comment': 'onEditComment',
        //'on:remove:comment': 'onRemoveComment',
        'on:irrelevant:comment': 'onSetAsIrrelevant',
        'action:confirmed': 'onSetAsIrrelevantConfirmed'
    },

    templateContext: function () {
        return {}
    },

    onRender: function () {
        var that = this;
        that.collection.fetch({
            success: function () {
                that.showChildView('body', new CommentsTableBody({
                    collection: that.collection,
                    canEdit: that.getOption('canEdit')
                }));
            },
            error: function (collection, response, options) {
                if (response.status == 401) {
                    actionsChannel.request("redirect:to:login");
                }
            }
        });

        this.confirmationModal = new YesNoConfirmationModal({
            tag: 'comment-irrelevant',
            message: "Set the comment as Irrelevant will effect the same comment in other entities. Are you sure?"
        });
        this.showChildView('confirmationModal', this.confirmationModal);
    },

    initialize: function (options) {
        var that = this;
        that.dboId = options.dboId;
        that.collection = new CommentsCollection();
        that.collection.url = this.collection.url + "/" + this.dboId;
    },

    add: function (commentModel) {
        this.collection.add(commentModel, {at: 0});
        this.triggerMethod('comment:count:changed');
    },

    update: function (commentModel) {
        var oldModel = this.collection.findWhere({id: commentModel.id});
        var oldModelIndex = this.collection.indexOf(oldModel);
        this.collection.remove([oldModel]);
        this.collection.add(commentModel, {at: oldModelIndex});
    },

    syncWithCount: function (cnt) {

        var that = this;
        if (cnt != that.collection.models.length) {
            that.collection.fetch();
        }

    },

    /*onEditComment: function (model) {
        this.triggerMethod('on:edit:comment', model);
    },

    onRemoveComment: function (model) {
        this.beingRemovedComment = model;
        this.confirmationModal.show();
    },*/

    onSetAsIrrelevant: function (model) {
        this.beingIrrelevantComment = model;
        this.confirmationModal.show();
    },
    
    onSetAsIrrelevantConfirmed: function (data) {
        if (data.tag === 'comment-irrelevant' && data.result == true) {
            this.setAsIrrelevant();
        }
        else {
            this.confirmationModal.hide();
        }
    },

    setAsIrrelevant: function () {
        var that = this;
        var commentId = that.beingIrrelevantComment.get('id');

        if (_.isEmpty(commentId))
            return;

        var dboId = that.dboId;

        utils.showSpinner();
        $.ajax({
            type: "POST",
            url: '/api/comment/' + dboId + '/' + commentId + '/irrelevant',
            statusCode: {
                200: function (modelUpdated) {
                    utils.hideSpinner();
                    $.notify({
                        message: 'The comment became as Irrelevant successfully'
                    }, {
                        type: 'success',
                        z_index: 2000,
                    });
                    that.update(modelUpdated);
                }
            },
            error: function (e) {
                utils.hideSpinner();
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });
    },

    /*onDeleteConfirmed: function (data) {
        if (data.tag === 'comment-remove' && data.result == true) {
            this.removeComment();
        }
        else {
            this.confirmationModal.hide();
        }
    },*/

    /*removeComment: function () {
        var that = this;
        var commentId = that.beingRemovedComment.get('id');

        if (_.isEmpty(commentId))
            return;

        var dboId = that.dboId;

        utils.showSpinner();
        $.ajax({
            type: "DELETE",
            url: '/api/comment/' + dboId + '/' + commentId,
            statusCode: {
                200: function (response) {
                    utils.hideSpinner();
                    that.collection.remove([that.beingRemovedComment]);
                    that.triggerMethod('comment:count:changed');
                    $.notify({
                        message: 'The comment removed successfully'
                    }, {
                        type: 'success',
                        z_index: 2000,
                    });
                }
            },
            error: function (e) {
                utils.hideSpinner();
                if (e.status == 401) {
                    actionsChannel.request("redirect:to:login");
                } else {
                    notificationsChannel.request('show:notification', e.responseJSON);
                }
            }
        });
    },*/

    addNewComment: function() {
        this.triggerMethod('on:new:comment');
    }
});

module.exports = CommentsTableView;


//////////////////
// WEBPACK FOOTER
// ./app/views/comments/comments-table-view.js
// module id = 268
// module chunks = 0